import React from "react";
import Header from "../Headers/Header";
import axios from "axios";
import { useDispatch } from "react-redux";
import { saveProductList } from "../../redux/userSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Slide from "../Slide/Slide";
import ImgHome from "../ImgHome/ImgHome";
// import Slidex3 from "../Slide/Slidex3";
// import AboutUs from "../AboutUs/AboutUs";
// import AboutThisProject from "../AboutThisProject/AboutThisProject";
import styles from "./Home.module.css";
import IconContainer from "./IconContainer";

function Home() {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.products);

  useEffect(() => {
    const getProducts = async () => {
      const response = await axios({
        url: `${process.env.REACT_APP_API_PORT}/products`,
        method: "GET",
      });
      dispatch(saveProductList(response.data));
    };
    getProducts();
  }, []); // eslint-disable-line

  return (
    products && (
      <div className="contenedor">
        <Header />
        <Slide />
        <ImgHome />
        <IconContainer />
      </div>
    )
  );
}

export default Home;
